<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Maintenance Requisition - Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="7">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Requisition Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.requestno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-append><span class="input-group-text">Request Date</span></b-input-group-append>
                            <b-form-input v-model="model.requestdate" type="date" @change="tanggalBerubah" :state="!$v.model.requestdate.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-input-group>
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" :state="!$v.model.asetkey.$error" readonly class="mr-1" ></b-form-input>  
                        <b-form-input v-model="model.asdesc" :state="!$v.model.asetkey.$error" readonly style="width:45% !important;"></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                        <b-input-group-prepend class="ml-2 pt-2 mr-1" ><span>Model/Type</span></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Request Detail</label></b-input-group-prepend>
                        <b-form-textarea :rows="3" :max-rows="4" v-model="model.inspectName" :state="!$v.model.inspectName.$error" ></b-form-textarea>
                    </b-input-group>
                </b-col>
                <b-col lg="5">
                    <b-row>
                        <b-col lg="7" >
                            <b-input-group >
                                <b-input-group-prepend><label>Estimate Cost</label></b-input-group-prepend>
                                <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.costEstimate" :precision="2"></my-number>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <h4>DIMENSION</h4>
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset"  :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import reqm from "../../apis/maintenrequest";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuFixedasset},
  mixins: [validationMixin],
  validations: {
        model: {
            asetkey: { required },
            requestdate: { required },
            inspectName: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        lkuRequestShow:false,
        lkuVendorShow: false,
        lkuFixedAssetData:{},
        lkuFixedAssetShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        model: {
            asetKey: 0,
            requestdate: moment().format('YYYY-MM-DD'),
            vendor_id: '',
            requestno: '',
            inspectName: '',
            inspectName: '',
            matauang:this.$store.state.user.matauang, 
            costEstimate: 0
        }
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function(){
        if (this.$route.params.requestkey)  {
          toastr.info('Loading WorkOrder Detail, please wait')
          try {
            const data = await reqm.detail(this.$route.params) ;
            // const data = await reqm.detail(this.$route.params);  
            const row = data[0];
            this.saveEnabled=((row.status || 0) === 0);
            row.requestdate = row.requestdate ? moment(row.requestdate).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
                // this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.requestdate  = moment().format('YYYY-MM-DD');
        }
  },
  methods: {
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            try {
                this.model.TableName = 'maintenance_requisition_schedule';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.requestkey = this.model.requestkey || '';
                    this.model.requestno = this.model.requestno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.requestdate = moment(row.requestdate).format('YYYY-MM-DD');
                    await reqm.save(row);
                    toastr.success("Complete successfully", "Save Order");
                    this.close();
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;            
                }

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuRequest: async function (_selected) {
        // this.model.requestkey = _selected.requestkey;
        // this.model.requestno = _selected.requestno;
        for (var key in _selected) {
            this.model[key] = row[key];
        }

        this.lkuRequestShow=false;
        this.updateDimHdr = !this.updateDimHdr;            
    },
    onSelectLkuVendor: async function (_selected) {
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.lkuVendorShow=false;
    },
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;
        this.model.asetkey = lkuData.selected.asetkey;
        this.model.asetid = lkuData.selected.asetid;
        this.model.asdesc = lkuData.selected.asdesc;
        this.model.lamathn = lkuData.selected.lamathn;
        this.model.lamabln = lkuData.selected.lamabln;
        this.model.lamathnB4 = lkuData.selected.lamathn;
        this.model.lamablnB4 = lkuData.selected.lamabln;
        this.model.NilaiNettB4 = lkuData.selected.NilaiNett;
        this.model.depaccumB4 = lkuData.selected.Penyusutan;
        this.model.catgname = lkuData.selected.catgname;
        this.model.matauang = lkuData.selected.matauang;
        this.model.asmodel = lkuData.selected.asmodel;
        this.model.asserial = lkuData.selected.asserial;
        this.model.asyermad = lkuData.selected.asyermad;
        this.model.supplierinfo = lkuData.selected.supplierinfo;
        this.model.aspurcpri = lkuData.selected.aspurcpri;
        this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');
    },

    // updateDimDtl2Hdr: function (dimDtl) {
    //     var dimHdr = this.model;
    //     this.dimension.forEach((dim) => {
    //         if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
    //             dimHdr[dim.value] = dimDtl[dim.value];
    //             dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
    //             dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimHdr = !this.updateDimHdr;
    // },
    // updateDimHdr2Dtl: function (dimDtl) {
    //     var dimHdr = this.model;
    //     dimDtl = dimDtl || this.ordLinesObj;
    //     this.dimension.forEach((dim) => {
    //         if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
    //             dimDtl[dim.value] = dimHdr[dim.value];
    //             dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
    //             dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimDtl = !this.updateDimDtl;
    // },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.poinput')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
